export enum TEACHER_PAYOUT_MODE {
  END_OF_MONTH = "end_of_month",
  ON_DEMAND = "on_demand",
}

export const TEACHER_PAYOUT_MODE_LABELS: Record<TEACHER_PAYOUT_MODE, string> = {
  [TEACHER_PAYOUT_MODE.END_OF_MONTH]: "Fin de mois",
  [TEACHER_PAYOUT_MODE.ON_DEMAND]: "À la demande",
};

export enum TEACHER_STANDING {
  RESTRICTED = "restricted",
  TRUSTED = "trusted",
}

export const TEACHER_STANDING_LABELS: Record<TEACHER_STANDING, string> = {
  [TEACHER_STANDING.RESTRICTED]: "Restreint",
  [TEACHER_STANDING.TRUSTED]: "Confiance",
};

export enum STRUCTURE_TYPE {
  AUTO_ENTREPRISE = "auto_entreprise",
  ASSOCIATION = "association",
  ENTREPRISE = "entreprise",
}

export const STRUCTURE_TYPE_LABELS: Record<STRUCTURE_TYPE, string> = {
  [STRUCTURE_TYPE.AUTO_ENTREPRISE]: "Auto-entreprise",
  [STRUCTURE_TYPE.ASSOCIATION]: "Association",
  [STRUCTURE_TYPE.ENTREPRISE]: "Entreprise",
};
